import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Ticket.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from '@mui/material/PaginationItem';

import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from "@material-ui/core";

// icons 
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { LuPencilLine } from "react-icons/lu";
import { FiEye } from "react-icons/fi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { GoReply } from "react-icons/go";
import { MdOutlineWatchLater } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";

// Elements

import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  ProfileDetailForm,
} from "./TicketManagementElement";


const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 6px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "50vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid #D9E3D9",

  },

  tableBodyRow: {
    border: "1px solid #D9E3D9",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    padding: "0.3rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#26344E",
    fontWeight: 500,
    // borderBottom: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
  },
  textMiddle: {
    padding: "0.3rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    backgroundColor: "#FFFFFF",
  },
  tablePaginationStyle: {
    border: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  }
}));


const TicketHistory = ({ setUsers, userData }) => {

  const param = useParams();
  // const { ticketId } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [userHistoryDetails, setUserHistoryDetails] = useState();
  const [statusHistryData, setStatusHistryData] = useState([]);

  const [reasonDeleteModal, setReasonDeleteModal] = useState(false);
  const [profileRejectionReason, setProfileRejectionReason] = useState("");


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update page and trigger data fetch
  };





  // Get user data
  useEffect(() => {
    getUserTicketConversationData(page);
  }, [page, rowsPerPage,]);

  // userViewHistory

  const getUserTicketConversationData = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/getUserTicketConversationData/${param?.id}`);
      setUserHistoryDetails(data?.data);
      setStatusHistryData(data?.data?.conversation)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      }
      else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.put(
        `/private/createAdminTicketConversation/${param?.id}`,
        {
          message: profileRejectionReason,
        }
      );

      //Show success toast with API message
      toast.success(response.data.message || "Updated successfully", {
        position: "top-right",
      });

      // Clear textarea and close modal
      setProfileRejectionReason("");
      setReasonDeleteModal(false);
      getUserTicketConversationData(page);
    } catch (error) {

      if (error?.response?.status === 419) {
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };





  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <DashboardHeading
              onClick={() => navigate("/ticketManagement")}
            >
              <IoIosArrowRoundBack style={{ fontSize: "2rem", cursor: "pointer" }} /> Ticket id #{userHistoryDetails?.ticketId ? userHistoryDetails.ticketId : 'N/A'}
            </DashboardHeading>
            <div className="mainpageticket">
              <div className="mainTicketBox">
                <div className="mainTicketBoxContent">
                  <div className="mainTicketBoxContentfirst">
                    <div className="ticketIssueContent">
                      <div className="ticketIssue">Issue Category <span className="ticketIssueData"> {userHistoryDetails?.category ? userHistoryDetails.category : 'N/A'}</span></div>
                      <div className="ticketIssue">Issue Sub Category <span className="ticketIssueData">{userHistoryDetails?.subCategory ? userHistoryDetails.subCategory : 'N/A'}</span></div>
                    </div>
                    {userHistoryDetails?.status !== 2 && (
                      <div className="ticketReply" onClick={() => setReasonDeleteModal(true)}>
                        <GoReply /> Reply
                      </div>
                    )}
                  </div>

                  <div className="ticketIssueData">{userHistoryDetails?.description ? userHistoryDetails.description : 'N/A'}</div>
                  <div className="ticketIssue">Raised On : <span className="ticketIssueData">{extractDate(userHistoryDetails?.createdAt ? userHistoryDetails.createdAt : 'N/A')}</span></div>
                </div>
              </div>
              <div className="mainpageticketchat">
                <div className="stepper-container-Ticket">

                  {(statusHistryData) && statusHistryData.length > 0 ? (
                    statusHistryData.map((data, index) => (
                      <div className="stepper-item-Ticket" key={index}>
                        <div className="stepper-line-Ticket" />
                        <div className="stepper-dot-Ticket" />
                        <div className="stepper-content-Ticket">
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className="stepper-status-Ticket">
                              {data.userDetails.firstName}  {data.userDetails.lastName} ( {data.userDetails.userType} )
                            </div>
                            <div className="stepper-date-Ticket">
                              <MdOutlineWatchLater style={{ fontSize: "1.2rem" }} /> {extractDate(get(data, "date"))}
                            </div>
                          </div>
                          <div className="textmsgTicket">
                            {(get(data, "message"))}
                          </div>
                          <hr style={{ color: "1px solid #E5E5E5" }} />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no-data">No data available</div>
                  )}
                </div>
              </div>
            </div>

          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {/* Modal for reason User  */}

      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={reasonDeleteModal}
        onClose={() => setReasonDeleteModal(false)}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <span>Reply to Team</span>
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setReasonDeleteModal(false)} />
            </div>

            <div style={{ marginTop: "1rem" }}>
              <textarea
                name="profile"
                className="reject_form"
                placeholder="Type here..."
                type="textarea"
                maxLength={100}
                value={profileRejectionReason}
                onChange={(e) => setProfileRejectionReason(e.target.value)}
                style={{ border: "1px solid #D9D9D9", color: "#484848", fontSize: "13px", fontFamily: "Roboto", fontWeight: "400" }}
              />
            </div>


            <div
              className="logout-button-Ticket"
              style={{ background: "#5088FB", cursor: "pointer" }}
              onClick={() => {
                handleSubmit();
                setReasonDeleteModal(false);
              }}
            >
              Submit
            </div>

          </div>


        }
        content={
          <>

          </>
        }
      />

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketHistory);






